// extracted by mini-css-extract-plugin
export default {"container":"MainContent_container__qoT-6","button":"MainContent_button__xFpb9","closeTag":"MainContent_closeTag__BVyP+","backgroundMobile":"MainContent_backgroundMobile__om10q"};